<template>
  <button :class="stClass" :active="active" @click="$emit('click')" v-label>
    <slot></slot>
  </button>
</template>

<script>
// import vRippleDirective from 'vuetify/es5/directives/ripple'
export default {
  directives: {
    // ripple: vRippleDirective
    label: {
      inserted (el) {
        el.setAttribute('data-label', el.textContent)
      },
      componentUpdated (el) {
        el.setAttribute('data-label', el.textContent)
      }
    }
  },
  props: ['solid', 'active'],
  computed: {
    stClass () {
      return {
        'st-btn': true,
        'st-btn-solid': this.solid != null
      }
    }
  }
}
</script>

<style lang="scss">
.st-btn {
  position: relative;
  border: 1px solid;
  border-radius: 1.8em;
  padding: 0.25em 1.25em;
  font-size: 16px;
  font-family: $font-CuratorRegular;
  color: $stblue;
  background-color: transparent;
  cursor: pointer;

  &::after {
    content: attr(data-label);
    position: absolute;
    top: -1px;
    bottom: -1px;
    left: -1px;
    right: -1px;
    padding: 0.25em 1.25em;
    color: white;
    border-radius: 1.8em;
    border: 1px solid;
    opacity: 0;
  }

  &:hover::after {
    opacity: 0.4;
  }

  &:focus {
    outline: 0;
    // box-shadow: 0 0 1px 1px black;
  }

  &[disabled] {
    background-color: #ccc;
    border-color: transparent;
    color: #999;
    cursor: not-allowed;
  }

  &[disabled]:hover::after {
    opacity: 0;
  }

  &[active]:not(.st-btn-solid),
  &.st-btn-solid:not([active]) {
    background-color: $stblue;
    border-color: transparent;
    color: #fff;

    &::after {
      background-color: #000;
      border-color: transparent;
    }

    &:hover::after {
      opacity: 0.2;
    }

    &[disabled] {
      background-color: #ccc;
      border-color: transparent;
      color: #999;
      cursor: not-allowed;
    }

    &[disabled]:hover::after {
      opacity: 0;
    }
  }
}
</style>
